// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3fjuA","title":"Info_title__1Cc9s","selects":"Info_selects__25QbA","requiredAsterisk":"Info_requiredAsterisk__3wP1z"};